/**
 * Administração › Usuários › Novo usuário — Nexora Grid (frontend, US-1804).
 *
 * Criado em: 19/10/2026 · Última modificação: 02/11/2026 · Versão: 2.0.0
 *
 * Cria o usuário e o backend envia o convite por e-mail (a senha nunca passa pela tela nem pela API).
 * v2.0 (US-4604, Sprint 46): cabeçalho com migalhas e "Voltar" para a lista como a pessoa deixou; formulário em grupos
 *   com rodapé fixo. Mesma chamada (`POST /v1/usuarios`).
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ErroApi } from "../api";
import { CabecalhoTela, enderecoDeVolta } from "../componentes/Tela";
import { NOMES } from "../nomes";
import { pode } from "../permissoes";
import { useSessao } from "../sessao";
import { corpoDoForm, dadosIniciais, FormUsuario, type DadosForm } from "./FormUsuario";
import type { UsuarioAdm } from "./tipos";
import "./admin-b.css";

export function UsuarioNovo() {
  const { usuario, empresa } = useSessao();
  const navegar = useNavigate();
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  if (!usuario || !pode.gerenciarUsuarios(usuario)) return <p className="nx-suave">Sem permissão para cadastrar usuários.</p>;

  const criar = async (d: DadosForm) => {
    setEnviando(true);
    setErro(null);
    try {
      const novo = await api<UsuarioAdm>("/v1/usuarios", { corpo: corpoDoForm(d, true) });
      navegar(`/admin/usuarios/${novo.id}?criado=1`);
    } catch (e) {
      setErro(e instanceof ErroApi ? (e.status === 409 ? "Esse login já existe." : e.message) : "Falha de rede.");
      setEnviando(false);
    }
  };

  return (
    <section className="tl-pagina admin-b">
      <CabecalhoTela voltar="/admin/usuarios" titulo="Novo usuário"
        migalhas={[{ texto: NOMES.administracao }, { texto: NOMES.usuarios, para: "/admin/usuarios" }, { texto: "Novo usuário" }]} />
      <p className="tl-texto">A pessoa recebe um convite por e-mail (válido por 48 horas) para confirmar o cadastro e definir a própria senha.</p>
      {erro && <p className="erro" role="alert">{erro}</p>}
      <FormUsuario ator={usuario} inicial={dadosIniciais(usuario, empresa)} novo enviando={enviando} textoBotao="Criar e enviar convite"
        aoEnviar={(d) => void criar(d)} aoCancelar={() => navegar(enderecoDeVolta("/admin/usuarios"))} />
    </section>
  );
}
